import Spacer from '@berlitz/spacer'
import { Row } from 'react-styled-flexboxgrid'
import * as React from 'react'
import { RectLoader } from '@components/Loader'
import { Profile, StyledCol, StyledH3Col } from './style'

const NotesLoader: React.FC = () => {
  return (
    <>
      <Row>
        <StyledH3Col xs={12} md={12}>
          <RectLoader width="200" height="23" />
        </StyledH3Col>
      </Row>

      <br />

      <Spacer size="lg" />

      <Row>
        {[1, 2, 3].map(item => (
          <StyledCol key={item} xs={12} md={12}>
            <Profile>
              <RectLoader width="250" height="26" />
            </Profile>
            <RectLoader width="500" height="28" />
          </StyledCol>
        ))}
      </Row>
    </>
  )
}

export default NotesLoader
